import { Component, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { DEFAULT_SOPO_CLUB_DATA, IClubData, SopoClubJoinConfirmData } from '../../interfaces/confirm';
import { SOPO_DIALOG_DATA, SopoDialogRef } from '../../interfaces/dialog';

@Component({
    selector: 'app-sopo-club-join-confirm',
    templateUrl: './sopo-club-join-confirm.component.html',
    styleUrls: ['./sopo-club-join-confirm.component.scss'],
    standalone: false
})
export class SopoClubJoinConfirmComponent implements OnInit, OnDestroy {
    dismissAfterTimeout: NodeJS.Timeout;
    header: string = '';
    body: IClubData = DEFAULT_SOPO_CLUB_DATA;
    dismissAfter: number = 0;
    okText: string = 'Ok';
    cancelText: string = 'Cancel';
    sCss: string[] = [];
    sopoDateTimeOptions: Intl.DateTimeFormatOptions = {
        day: 'numeric',
        month: 'short',
        year: '2-digit',
        hour: 'numeric',
        minute: '2-digit',
        second: '2-digit',
    };

    constructor(
        @Inject(SOPO_DIALOG_DATA) data: SopoClubJoinConfirmData,
        private renderer: Renderer2,
        private sopoDialogRef: SopoDialogRef,
    ) {
        if (data.header) this.header = data.header;
        if (data.clubData) this.body = data.clubData;
        if (data.dismissAfter) this.dismissAfter = data.dismissAfter;
        if (data.okText) this.okText = data.okText;
        if (data.cancelText) this.cancelText = data.cancelText; 
        if (data.sCss) this.sCss = data.sCss
    }

    ngOnInit() {
        if (this.dismissAfter && this.dismissAfter > 0) {
            this.dismissAfterTimeout = setTimeout(() => {
                this.close(false);
            }, this.dismissAfter);
        }
    }

    ngAfterViewInit(): void {
        this.getContainerCss();
    }

    getContainerCss() {
        const container = document.getElementsByClassName('now-opening')[0];
        if (this.sCss && this.sCss.length !== 0) {
            for (let className of this.sCss) {
                this.renderer.addClass(container, className);
            };
        }
        this.renderer.removeClass(container, 'now-opening');
    }

    close(answer: boolean) {
        this.sopoDialogRef.close(answer);
    }

    ngOnDestroy(): void {
        if (this.dismissAfterTimeout) clearTimeout(this.dismissAfterTimeout);
    }
}
